
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWipers as ObiWipersElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wipers.js';
 
 
 

 
 export const ObiWipers = createComponent({
   react: React,
   tagName: 'obi-wipers',
   elementClass: ObiWipersElement,
   events: {
     
   }
  });
 
 